"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBboxStyle = void 0;
var utils_1 = require("../../../utils");
var bbox_style_default_1 = require("../../default-values/bbox-style-default");
exports.IBboxStyle = (0, utils_1.IRecord)(bbox_style_default_1.bboxStyleDefault);
